import React, { useState } from "react";
import { useI18n } from "../i18n";
import useSeo from "../hooks/useSeo";
import { api } from "../api";
import { Send, CheckCircle2 } from "lucide-react";

export default function Contact() {
  const { t, lang } = useI18n();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useSeo({
    title: lang === "fr"
      ? "Contact — Dr Trade Bots | Support Bot de Trading MT5"
      : "Contact — Dr Trade Bots | MT5 Trading Bot Support",
    description: lang === "fr"
      ? "Contactez l'équipe Dr Trade Bots pour toute question sur le bot de trading MT5 Dr Trade Scalper Pro. Réponse sous 24h ouvrées. Support technique inclus pendant la licence."
      : "Contact the Dr Trade Bots team for any question about the Dr Trade Scalper Pro MT5 trading bot. Reply within 24 business hours. Technical support included during license.",
    keywords: lang === "fr"
      ? "contact Dr Trade Bots, support EA MT5, aide robot trading, support MetaTrader 5"
      : "contact Dr Trade Bots, MT5 EA support, trading robot help, MetaTrader 5 support",
    path: "/contact",
  });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/contact", form);
      setSent(true);
    } catch (e) {
      setErr(e.response?.data?.detail || "Erreur réseau");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="page-contact">
      <div className="mb-10">
        <div className="section-overline mb-3">{t("contact.overline")}</div>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter mb-3">{t("contact.title")}</h1>
        <p className="text-zinc-400">{t("contact.sub")}</p>
      </div>

      {sent ? (
        <div className="glass rounded-2xl p-10 text-center" data-testid="contact-success">
          <CheckCircle2 className="h-10 w-10 text-emerald-400 mx-auto mb-3" />
          <div className="text-lg font-semibold">{t("contact.sent")}</div>
        </div>
      ) : (
        <form onSubmit={submit} className="glass rounded-2xl p-6 sm:p-8 space-y-4" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <input
              required
              placeholder={t("contact.name")}
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="px-3 py-2.5 rounded-lg text-sm w-full"
              data-testid="contact-name"
            />
            <input
              required
              type="email"
              placeholder={t("contact.email")}
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="px-3 py-2.5 rounded-lg text-sm w-full"
              data-testid="contact-email"
            />
          </div>
          <input
            required
            placeholder={t("contact.subject")}
            value={form.subject}
            onChange={(e) => setForm({ ...form, subject: e.target.value })}
            className="px-3 py-2.5 rounded-lg text-sm w-full"
            data-testid="contact-subject"
          />
          <textarea
            required
            placeholder={t("contact.message")}
            rows={6}
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className="px-3 py-2.5 rounded-lg text-sm w-full resize-none"
            data-testid="contact-message"
          />
          {err && <div className="text-xs text-red-400">{err}</div>}
          <button
            type="submit"
            disabled={busy}
            className="btn-primary px-5 py-2.5 rounded-lg text-sm inline-flex items-center gap-2 disabled:opacity-40"
            data-testid="contact-submit"
          >
            <Send className="h-4 w-4" /> {t("contact.send")}
          </button>
        </form>
      )}
    </div>
  );
}
